var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseRegular = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.41652 11.425L4.84813 7.00299L0.41652 2.57138C-0.13242 2.02244 -0.151681 1.02086 0.435781 0.433403C1.01361 -0.154058 2.02482 -0.125167 2.56413 0.414142L6.99574 4.84575L11.4274 0.423773C11.9956 -0.144428 12.9682 -0.144428 13.5557 0.443034C14.1432 1.02086 14.1432 2.00318 13.575 2.57138L9.15297 7.00299L13.575 11.425C14.1432 11.9932 14.1432 12.9755 13.5557 13.5533C12.9779 14.1408 11.9956 14.1504 11.4274 13.5726L6.99574 9.1506L2.56413 13.5822C2.02482 14.1311 1.02324 14.1504 0.435781 13.5629C-0.151681 12.9851 -0.13242 11.9739 0.41652 11.425Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseRegular);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CloseRegular.69280fa386798141e2378e934d9bb317.svg";